<template>
    <div class="show">
        <div>
            <div class="canvas">
                <div class="canvas-edit">
                    <div class="clear">清除结果</div>
                </div>
                <div id="mycanvas"></div>
            </div>
            <pre id="output" ></pre>
        </div>
    </div>
</template>

<script>
export default {
  name: 'PyShow'
}
</script>

<style scoped>
    .clear{
        display: inline-block;
        width: 100px;
        height: 28px;
        border-radius: 20px;
        border: 1px solid gray;
        text-align: center;
        line-height: 28px;
        cursor: pointer;
        margin-left: 20px;
        vertical-align: top;
        margin-top: 10px;
        font-size: 14px;
    }
    .show{
        display: inline-block;
        width: 400px;
        height: 100%;
        border-left: 1px solid lightgray;
        float: right;
        background: white;
    }
    .show>div{
        display: flex;
        display: -webkit-flex;
        flex-direction: column;
        -webkit-flex-direction: column;
        flex-wrap: nowrap;
        height: 100%;
    }
    .canvas{
        margin-top: 48px;
        width: 100%;
        flex: 1;
        /*height: 50%;*/
        display: block;
    }
    .canvas-edit{
        height: 50px;
        width: 100%;
    }
    #output{
        background-color: #323B4A;
        margin: 0;
        color: white;
        padding: 10px 0 0 0;
        font-size: 15px;
        width: 100%;
        /*height: calc( 50% - 60px);*/
        height: 50%;
        display: block;
        border: 0;
    }
    #mycanvas{
        background-color: white;
        outline: none;
    }

</style>



// WEBPACK FOOTER //
// src/components/PyShow.vue